<template>
  <div class="care-modern">
    <NavBar />
    <AuthBySessionExpired />

    <!-- Modal Create -->
    <b-modal
      size="md"
      no-close-on-backdrop
      hide-footer
      id="modal-create-care"
      title="CRIAR CUIDADO"
      @hidden="clearModalCreateCare"
    >
      <div class="col-md-12">
        <label-required-field label="CATEGORIA" />
        <b-input v-model="category" />

        <label-required-field label="NOME" />
        <b-input v-model="name" />
      </div>

      <ErrorsMessages :errors="errors" />

      <div class="text-right mt-5">
        <v-btn @click="create" class="btn-modern btn-modern-save">
          <i class="fas fa-save mr-1"></i>
          SALVAR
        </v-btn>
      </div>
    </b-modal>

    <!-- Modal Edit -->
    <b-modal
      size="md"
      no-close-on-backdrop
      hide-footer
      id="modal-edit-care"
      title="EDITAR CUIDADO"
    >
      <div class="col-md-12">
        <label-required-field label="CATEGORIA" />
        <b-input v-model="selectCare.category" />

        <label-required-field label="NOME" />
        <b-input v-model="selectCare.name" />

        <label-required-field label="STATUS" />
        <b-form-select
          v-model="selectCare.active"
          :options="[
            { value: 1, text: 'ATIVO' },
            { value: 0, text: 'INATIVO' },
          ]"
        />
      </div>

      <ErrorsMessages :errors="errors" />

      <div class="text-right mt-5">
        <v-btn @click="edit" class="btn-modern btn-modern-save">
          <i class="fas fa-save mr-1"></i>
          SALVAR
        </v-btn>
      </div>
    </b-modal>

    <div class="care-container">
      <!-- Header Section -->
      <div class="care-header">
        <div class="care-header-content">
          <div class="back-button-section">
            <v-btn class="btn-return" @click="handleToBack">
              <i class="fas fa-arrow-left mr-2"></i>
              Voltar
            </v-btn>
          </div>

          <div class="title-section">
            <h1 class="care-page-title">
              <i class="fas fa-hands-helping title-icon"></i>
              Cuidados
            </h1>
            <p class="care-page-subtitle">
              Gerencie o catálogo e visualize os seus cuidados e da instituição
            </p>
          </div>

          <div
            v-if="permission('read', 'resident_care_prescription')"
            class="actions-section"
          >
            <v-btn
              class="care-btn-add"
              @click="$bvModal.show('modal-create-care')"
            >
              <i class="fas fa-plus mr-2"></i>
              NOVO CUIDADO
            </v-btn>
          </div>
        </div>
      </div>

      <!-- Content Section -->
      <div class="care-content">
        <!-- Filters Section -->
        <div class="care-filters-section">
          <div class="care-filters-card">
            <div class="care-filter-group">
              <label class="care-filter-label">
                <i class="fas fa-search care-filter-icon"></i>
                Pesquisar cuidados
              </label>

              <v-text-field
                v-model="search"
                placeholder="Digite o nome ou a categoria"
                outlined
                dense
                hide-details
                class="care-modern-input"
                @input="paginate"
              />
            </div>
          </div>
        </div>

        <!-- Data Table Section -->
        <div class="care-table-section">
          <div class="care-table-card">
            <b-overlay
              :show="loading"
              opacity="0.99"
              class="care-loading-overlay"
            >
              <v-data-table
                :headers="headers"
                :items="cares"
                item-key="id"
                :footer-props="{
                  'items-per-page-options': [50, 75, 100],
                  'items-per-page-text': 'Mostrar',
                }"
                class="care-table"
                :no-data-text="'Nenhum agendamento encontrado'"
                :loading-text="'Carregando agendamentos...'"
              >
                <template v-slot:[`item.user_name`]="{ item }">
                  <div v-if="item.type == 'ADMIN'">
                    <span class="care-type-badge care-type-specific">
                      PADRÃO
                    </span>
                  </div>

                  <div v-if="item.type == 'REST_HOME'" class="care-user-cell">
                    <div class="care-user-avatar">
                      <img
                        v-if="item.user_photo_url"
                        :src="item.user_photo_url"
                        :alt="item.user_name"
                        class="care-user-photo"
                      />
                      <i v-else class="fas fa-user"></i>
                    </div>
                    <span class="care-user-name">{{ item.user_name }}</span>
                  </div>
                </template>

                <template v-slot:[`item.type`]="{ item }">
                  <span
                    class="care-type-badge"
                    :class="
                      item.type == 'ADMIN'
                        ? 'care-type-specific'
                        : 'care-type-diverse'
                    "
                  >
                    {{ item.type == "ADMIN" ? "ESPECÍFICO" : "DIVERSOS" }}
                  </span>
                </template>

                <template v-slot:[`item.active`]="{ item }">
                  <span
                    class="care-status-badge"
                    :class="
                      item.active == 1
                        ? 'care-status-active'
                        : 'care-status-inactive'
                    "
                  >
                    {{ item.active == 1 ? "ATIVO" : "INATIVO" }}
                  </span>
                </template>

                <template v-slot:[`item.actions`]="{ item }">
                  <v-btn
                    v-if="
                      permission('read', 'resident_care_prescription') &&
                      item.type == 'REST_HOME'
                    "
                    small
                    class="care-btn-action-edit"
                    @click="openEditModal(item)"
                  >
                    <i class="fas fa-edit mr-1"></i>
                    Editar
                  </v-btn>
                </template>
              </v-data-table>
            </b-overlay>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";
import AuthBySessionExpired from "../templates/Components/AuthBySessionExpired";
import ErrorsMessages from "../templates/Components/ErrorsMessages";
import LabelRequiredField from "../templates/Components/LabelRequiredField";
import toast from "../lib/ToastNotification";
import api from "../services/api";
import routes from "../routes";
import permission from "../lib/permission";
import { formatDate } from "../lib/format";

export default {
  name: "CaresManagement",

  components: {
    NavBar,
    AuthBySessionExpired,
    ErrorsMessages,
    LabelRequiredField,
  },

  data() {
    return {
      loading: false,

      selectCare: {
        category: "",
        name: "",
      },

      total: 0,

      search: "",

      category: "",

      name: "",

      headers: [
        { text: "CADASTRADO", value: "user_name", sortable: false },
        { text: "TIPO", value: "type", sortable: false },
        { text: "CATEGORIA", value: "category", sortable: false },
        { text: "NOME", value: "name", sortable: false },
        { text: "STATUS", value: "active", sortable: false },
        { text: "AÇÕES", value: "actions", sortable: false },
      ],

      cares: [],

      errors: [],
    };
  },

  created() {
    this.paginate();
  },

  methods: {
    formatDate,
    permission,

    async paginate() {
      try {
        this.loading = true;

        const { search } = this;

        let params = { search };

        const response = await api.get("/care", {
          params,
        });

        const { cares, total } = response.data;

        this.cares = cares;

        this.total = total;

        this.loading = false;
      } catch (error) {
        this.loading = false;

        console.log(error);
      }
    },

    async create() {
      try {
        this.loading = true;

        let { category, name } = this;

        let params = { category, name };

        const response = await api.post("/care", params);

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");

          await this.paginate();

          this.$bvModal.hide("modal-create-care");

          this.errors = [];
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async edit() {
      try {
        this.loading = true;

        let { id, category, name, active } = this.selectCare;

        let params = { id, category, name, active };

        const response = await api.put("/care", params);

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");

          await this.paginate();

          this.$bvModal.hide("modal-edit-care");

          this.errors = [];
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    handleModalCreate() {
      console.log("teste");
    },

    clearModalCreateCare() {
      this.category = "";
      this.name = "";
    },

    openEditModal(item) {
      this.selectCare = item;

      this.$bvModal.show("modal-edit-care");
    },

    handleToBack: () => routes.go(-1),
  },
};
</script>

<style scoped>
.care-modern {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
}

.care-container {
  max-width: 95%;
  margin: 0 auto;
  padding: 0 24px;
}

.care-header {
  padding: 24px 0;
  background: white;
  border-radius: 0 0 24px 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  margin-bottom: 32px;
}

.care-header-content {
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  gap: 24px;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 24px;
}

.care-page-title {
  font-size: 32px;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
  display: flex;
  align-items: center;
}

.title-icon {
  color: #0f65b0;
  margin-right: 12px;
}

.care-page-subtitle {
  color: #64748b;
  margin: 4px 0 0 0;
  font-size: 16px;
}

.care-btn-add {
  background: linear-gradient(135deg, #4e9130 0%, #1e884d 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 12px 24px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  box-shadow: 0 4px 15px rgba(78, 145, 48, 0.3) !important;
  transition: all 0.3s ease !important;
}

.care-btn-add:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(78, 145, 48, 0.4) !important;
}

.care-content {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.care-filters-section {
  margin-bottom: 8px;
}

.care-filters-card {
  background: white;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.care-filter-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 400px;
}

.care-filter-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 4px;
}

.care-filter-icon {
  color: #6b7280;
  font-size: 14px;
}

.care-table-section {
  margin-bottom: 32px;
}

.care-table-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  overflow: hidden;
}

.care-loading-overlay {
  border-radius: 16px;
}

.care-table {
  background: transparent !important;
}

.care-type-badge,
.care-status-badge {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.care-type-specific {
  background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);
  color: #2563eb;
  border: 1px solid #60a5fa;
}

.care-type-diverse {
  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
  color: #059669;
  border: 1px solid #34d399;
}

.care-status-active {
  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
  color: #059669;
  border: 1px solid #34d399;
}

.care-status-inactive {
  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
  color: #dc2626;
  border: 1px solid #f87171;
}

.care-btn-action-edit {
  background: linear-gradient(135deg, #1d75be 0%, #155a8a 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 8px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  font-size: 12px !important;
  box-shadow: 0 2px 8px rgba(29, 117, 190, 0.3) !important;
  transition: all 0.3s ease !important;
}

.care-btn-action-edit:hover {
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 12px rgba(29, 117, 190, 0.4) !important;
}

.care-user-avatar {
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, #0f65b0 0%, #1e40af 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 12px;
}

.care-user-photo {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
  transition: transform 0.2s ease;
}

.care-user-cell {
  display: flex;
  align-items: center;
  gap: 12px;
}

.care-user-name {
  font-weight: 500;
  color: #1e293b;
}

@media (max-width: 1024px) {
  .care-header-content {
    grid-template-columns: 1fr;
    gap: 16px;
    text-align: center;
  }

  .care-page-title {
    justify-content: center;
  }
}

@media (max-width: 768px) {
  .care-container {
    padding: 0 16px;
  }

  .care-header {
    padding: 16px 0;
    margin-bottom: 24px;
  }

  .care-header-content {
    padding: 0 16px;
  }

  .care-page-title {
    font-size: 24px;
  }

  .care-filters-card,
  .care-table-card {
    border-radius: 12px;
    padding: 16px;
  }
}

@media (max-width: 480px) {
  .care-btn-add {
    padding: 10px 16px !important;
    font-size: 14px !important;
  }

  .care-page-title {
    font-size: 20px;
  }

  .care-page-subtitle {
    font-size: 14px;
  }
}

.care-modern-input >>> .v-input__control {
  border-radius: 8px !important;
}

.care-modern-input >>> .v-text-field__slot input {
  font-weight: 500 !important;
  padding: 12px 0 !important;
}

.care-table >>> .v-data-table__wrapper {
  border-radius: 0 !important;
}

.care-table >>> .v-data-table thead th {
  background-color: #f8fafc !important;
  color: #374151 !important;
  font-weight: 600 !important;
  font-size: 12px !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  border-bottom: 2px solid #e5e7eb !important;
}

.care-table >>> .v-data-table tbody tr:hover {
  background-color: #f8fafc !important;
}
</style>